import { Tooltip } from "antd";
import styles from "./style.module.less";

export const CompletedDot = () => {
    return (
        <div className={styles.completedDot}>
            <Tooltip placement="top" title="Completed">
                <i className="ri-record-circle-fill"></i>
            </Tooltip>
        </div>
    );
}